import React from 'react';
import { SalesPage } from './components/SalesPage';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  // Initialize Meta Pixel on app load
  useMetaPixel('1497007874735639');
  return <SalesPage data-id="element-0" />;
}